import { render } from 'react-dom';
import Routers from './Routers';
import moment from 'moment';
import 'assets/js/themeSwitcher';

moment.updateLocale('nl', {
  weekdays: [
    'Zondag',
    'Maandag',
    'Dinsdag',
    'Woensdag',
    'Donderdag',
    'Vrijdag',
    'Zaterdag'
  ],
  monthsShort: [
    'Jan',
    'Feb',
    'Mrt',
    'Apr',
    'Mei',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Okt',
    'Nov',
    'Dec'
  ]
});

global.theme.init();

render(<Routers />, document.getElementById('app'));
